var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 89,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.1 83.5a12.5 12.5 0 0 1-9.6 4.5h-95a12.5 12.5 0 0 1-9.6-4.5l45.85-38.2 4.75 3.25c3.913 2.7 9.087 2.7 13 0l4.75-3.25 45.85 38.2z",
    fill: "#FFD044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.8 13.45 72.25 45.3l-4.75 3.25a11.445 11.445 0 0 1-13 0l-4.75-3.25L3.2 13.4A12.555 12.555 0 0 1 13.5 8h95a12.335 12.335 0 0 1 10.3 5.45z",
    fill: "#FFF2B4"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFDF72",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.75 45.3 3.9 83.5a12.445 12.445 0 0 1-2.9-8v-55a12.32 12.32 0 0 1 2.2-7.1l46.55 31.9zM121 20.5v55a12.445 12.445 0 0 1-2.9 8L72.25 45.3l46.55-31.85a12.278 12.278 0 0 1 2.2 7.05z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(104)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#6173FE",
    cx: 12.5,
    cy: 12.5,
    r: 12.5
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontSize: 13,
    fontWeight: 500,
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 8,
    y: 16
  }, "1"))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIllustration);
export default __webpack_public_path__ + "static/media/email-illustration.5aa736cf.svg";
export { ForwardRef as ReactComponent };